// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__101I5","left":"StickyBox_left__2Iyrf","right":"StickyBox_right__svKsK"};